// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-content[data-v-6533296a]{width:100%;height:100%}.main-content h1[data-v-6533296a]{margin-bottom:16px}.error-message[data-v-6533296a],.info-message[data-v-6533296a]{padding:48px;background-color:#fff;border-radius:6px}.messenger>div[data-v-6533296a]{display:flex;align-items:center}.messenger>div .v-icon[data-v-6533296a]{margin-right:6px}", ""]);
// Exports
module.exports = exports;
